"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconFireplaceFilled = function IconFireplaceFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.17 10.48H10.87C9.95676 10.4418 9.06513 10.7644 8.38778 11.3781C7.71043 11.9918 7.30173 12.8474 7.25 13.76V38.5C7.25 39.0523 7.69772 39.5 8.25 39.5H9.7C10.2523 39.5 10.7 39.0523 10.7 38.5V21.89C10.7 18.08 14.15 14.96 18.36 14.96H31.69C35.89 14.96 39.34 18.08 39.34 21.89V38.5C39.34 39.0523 39.7877 39.5 40.34 39.5H41.8C42.3523 39.5 42.8 39.0523 42.8 38.5V13.76C42.7483 12.8456 42.3382 11.9885 41.6587 11.3745C40.9791 10.7605 40.0849 10.4391 39.17 10.48Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.52 18.48C21.52 18.48 21.77 20.4 21.78 21.6C21.9138 23.7071 21.2296 25.7847 19.87 27.4C18.7201 28.6217 18.0737 30.2324 18.06 31.91C18.06 38.91 23.83 39.5 23.83 39.5C23.0922 38.2621 22.6955 36.851 22.68 35.41C22.7584 33.8888 23.371 32.444 24.41 31.33C24.41 31.33 23.83 34.83 25.56 34.83C26.34 34.83 26.71 33.66 26.71 33.66C27.0822 34.168 27.2851 34.7803 27.29 35.41C27.3918 36.8654 26.9853 38.311 26.14 39.5C26.14 39.5 31.9 38.92 31.9 31.91C31.9 28.41 28.44 26.07 28.44 26.07V27.82C28.4454 27.9739 28.4196 28.1273 28.3641 28.2709C28.3086 28.4145 28.2246 28.5454 28.1171 28.6557C28.0096 28.766 27.881 28.8533 27.7388 28.9125C27.5966 28.9717 27.444 29.0015 27.29 29C25.77 29 26.14 26.66 26.14 25.5C26.2352 24.1111 26.0376 22.7177 25.56 21.41C24.89 19.68 21.52 18.48 21.52 18.48Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43 41.5H7C6.17157 41.5 5.5 42.1716 5.5 43C5.5 43.8284 6.17157 44.5 7 44.5H43C43.8284 44.5 44.5 43.8284 44.5 43C44.5 42.1716 43.8284 41.5 43 41.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.85 8.42H11.15C10.4467 8.43138 9.74769 8.30922 9.08997 8.06C8.98215 8.02284 8.8809 7.96884 8.78997 7.9C8.62997 7.76 8.48997 7.59 8.32997 7.45L7.89997 7.05L7.05997 6.29L6.89997 6.14C6.71848 5.97518 6.59038 5.75988 6.53212 5.52174C6.47386 5.28359 6.4881 5.03347 6.573 4.80348C6.65791 4.57348 6.80961 4.37411 7.00863 4.23095C7.20765 4.08778 7.44492 4.00736 7.68997 4H42.31C42.555 4.00736 42.7923 4.08778 42.9913 4.23095C43.1903 4.37411 43.342 4.57348 43.4269 4.80348C43.5118 5.03347 43.5261 5.28359 43.4678 5.52174C43.4096 5.75988 43.2815 5.97518 43.1 6.14L41.54 7.58C41.3763 7.74559 41.1952 7.8931 41 8.02C40.3267 8.32692 39.5885 8.46425 38.85 8.42V8.42Z",
    fill: color
  }));
};

IconFireplaceFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconFireplaceFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconFireplaceFilled;
exports.default = _default;